import root from './root'
import './loader'
import './gm'
import './player'
import './plugins'

window.MIDI = root
export default root



/** WEBPACK FOOTER **
 ** ./~/.5.0.0@standard-loader!./src/index.js
 **/